export default "__VITE_ASSET__BoJvrOif__"